import { Routes, Route } from "react-router-dom";

import IncidentReportListScreen from "screens/App/CRM/IncidentReport/IncidentReportListScreen";
import IncidentReportInfoScreen from "screens/App/CRM/IncidentReport/IncidentReportInfoScreen";
import IncidentReportDetailScreen from "screens/App/CRM/IncidentReport/IncidentReportDetailScreen";
import IncidentReportEditScreen from "screens/App/CRM/IncidentReport/IncidentReportEditScreen";
import IncidentReportCreateScreen from "screens/App/CRM/IncidentReport/IncidentReportCreateScreen";
import { NotFoundScreen } from "screens/NotFoundScreen";

const IncidentReportRouter = () => {
  return (
    <Routes>
      <Route path="list" element={<IncidentReportListScreen />} />
      <Route path="create" element={<IncidentReportCreateScreen />} />
      <Route path=":id/detail" element={<IncidentReportDetailScreen />} />
      <Route path=":id/edit" element={<IncidentReportEditScreen />} />
      <Route path="info" element={<IncidentReportInfoScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default IncidentReportRouter;
